export default "__VITE_PUBLIC_ASSET__0c1c6c84__"